var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"promotion"},[_c('div',{staticClass:"promotion__title"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('discountProposition')))])]),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }